import "./footer.css";

import React from "react";
import { Link } from "react-router-dom";

import { NAV_LINKS, CONTACT_DETAILS, PAGE_ROUTES } from "../../utils/stateTypes";
import { SectionLink } from "./TopNav";

const Footer = () => {
  return (
    <footer className={"footer"}>
      <div className={"container"}>
        <div className={"footer-grid"}>
          <Link
            to={PAGE_ROUTES.HOME}
            className={"footer-logo"}
          >
            <img
              src={"/images/logo.png"}
              alt={"Corlea Geyer Attorneys Conveyancers"}
              width={780}
              height={258}
              loading={"lazy"}
            />
          </Link>

          <div className={"footer-col"}>
            <h2 className={"footer-heading"}>Menu</h2>
            <ul>
              {NAV_LINKS.map((link) => (
                <li key={link.section}>
                  <SectionLink section={link.section}>{link.label}</SectionLink>
                </li>
              ))}
            </ul>
          </div>

          <div className={"footer-col footer-col-contact"}>
            <h2 className={"footer-heading"}>Contact</h2>
            <ul>
              <li>
                <a href={CONTACT_DETAILS.PHONE_LINK}>{CONTACT_DETAILS.PHONE}</a>
              </li>
              <li>
                <a href={`mailto:${CONTACT_DETAILS.EMAIL}`}>{CONTACT_DETAILS.EMAIL}</a>
              </li>
            </ul>
          </div>
        </div>

        <p className={"footer-copyright"}>
          © {new Date().getFullYear()} by Corlea Geyer. Created by{" "}
          <a
            href={"https://tap-x.com/"}
            target={"_blank"}
            rel={"noopener noreferrer"}
          >
            TapX
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
